import React from 'react';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param JSX children: components for preview
 * @param classWith: to set a width for the component, but it will always be centered
 */
const CenterPhotoPicker = ({ children, classWith='w-100' }) => {

    return (<div className="p-0 m-0 d-flex flex-column justify-content-center align-items-center align-self-stretch">
        <div className={`${classWith} p-0 m-0 d-flex flex-column justify-content-center align-items-center`}>
            {children}
        </div>
    </div>)
}

export default CenterPhotoPicker;
